import {Fragment, useContext, useRef, useState} from 'react'
import {Dialog, Transition} from '@headlessui/react'
import { UserContext } from '../../context/UserContext';
import { APIChangeUserAccess } from '../../api/companies/Companies';
import {TfiClose} from "react-icons/tfi";



export const ChangeAccess = ({openChangePermission, setOpenChangePermission, associate, getAssociates, associates}) => {
    const {user} = useContext(UserContext);
    const cancelButtonRef = useRef(null)
    const [permission, setPermission] = useState(associate?.permission);

    const handelChangeAccess = async () => {
        if (!associate || isOwnUser || permission === associate.permission) {
            getAssociates()
            setOpenChangePermission(false)
            return
        }
        await APIChangeUserAccess(user.companyId, associate.id, permission )
        getAssociates()
        setOpenChangePermission(false)
    }

    const isOwnUser = associate?.entity_id === user.id;

    return (
        <Transition.Root show={openChangePermission} as={Fragment}>
            <Dialog className="relative z-10" initialFocus={cancelButtonRef} onClose={setOpenChangePermission}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                    <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                            enterTo="opacity-100 translate-y-0 sm:scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        >

                            <Dialog.Panel className='flex max-w-2xl flex-col max-h-full sm:max-h-max h-full md:h-auto rounded-lg bg-white text-left shadow-xl transition-all w-full relative'>
                                <button
                                    type='button'
                                    className='absolute z-40 lg: lg:-top-6 lg:-right-6 top-2 right-2'
                                    onClick={() => setOpenChangePermission(false)}
                                    ref={cancelButtonRef}
                                >
                                    <TfiClose className={"lg:size-16 border-gray-500/80 border-2 bg-white hover:bg-gray-300 lg:p-4 size-12 p-2 lg:rounded-full rounded-md"}/>
                                </button>


                                <div className='flex w-full h-full'>
                                    <div className={' flex flex-col w-full'}>
                                        <Dialog.Title
                                            as='h3'
                                            className='pt-8 px-8  font-bold text-2xl leading-6 text-gray-900-'>
                                            Zugriffsrechte ändern
                                        </Dialog.Title>
                                        <div className='p-8 pb-0 flex flex-col flex-1  overflow-y-auto'>
                                            <p className="text-sm text-gray-600/60">
                                                Moechten Sie die Zugriffsrechte von {associate?.user_name} ({associate.user_email}) auf {user.myCompanies.find(company => company.target_id === user.companyId)?.company_name} wirklich ändern?
                                            </p>
                                        </div>
                                        <div className="p-8">
                                            <div >
                                                <select
                                                    id="status"
                                                    name="status"
                                                    value={permission}
                                                    onChange={(e) => {
                                                        setPermission(e.target.value);
                                                    }}
                                                    className="block w-full rounded-md border-0 p-3 text-gray-900 w-full  ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                                                >
                                                    <option value="admin">Admistrator</option>
                                                    <option value="user">Benutzer</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="p-8 pt-0 sm:flex-row-reverse flex w-full flex-col-reverse gap-4">
                                            <button
                                                type="button"
                                                className={"text-center truncate items-center rounded-md bg-white text-gray-900  border-gray-900 border-2 disabled:text-gray-600/40 disabled:border-gray-500 px-4 py-3 text-sm font-semibold"}
                                                onClick={handelChangeAccess}
                                            >
                                                Zugriff ändern
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </Dialog.Panel>

                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition.Root>
    )
}
